import React from "react";
import { useDashboardDomainContext } from "../../DashboardDomainProvider";
import EChartsCanvas from "./EChartsCanvas";
import { useVisualPreviewData } from "./useVisualPreviewData";

const getRenderSignature = (renderModel) => {
  const optionJson =
    typeof renderModel?.OptionJson === "string"
      ? renderModel.OptionJson
      : JSON.stringify(renderModel?.OptionJson ?? "");

  return [
    renderModel?.Theme ?? "",
    renderModel?.Renderer ?? "",
    renderModel?.DevicePixelRatio ?? "",
    optionJson,
  ].join("|");
};

export default function VisualPreviewChart({
  visual,
  style = { width: "100%", height: "100%" },
}) {
  const dashboardContext = useDashboardDomainContext();
  const preview = useVisualPreviewData({
    visual,
    pageKey: dashboardContext?.selectedPageData?.Key ?? null,
  });
  const renderSignature = getRenderSignature(preview.renderModel);

  return (
    <EChartsCanvas
      key={`preview-chart-${visual?.VisualTypeId ?? visual?.VisualId ?? "new"}-${renderSignature}`}
      renderModel={preview.renderModel}
      isLoading={preview.isLoading}
      status={preview.status}
      error={preview.error}
      style={style}
    />
  );
}
